// CreateCasePage.tsx
import { Container, Title, Text, Button, Group } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import CreateCaseWizard from './index';

export default function CreateCasePage() {
  const navigate = useNavigate();

  return (
    <Container size="lg" py="xl">
      <Group justify="space-between" mb="md">
        <div>
          <Title order={2}>New Case</Title>
          <Text c="dimmed" size="sm">Create a new care support case.</Text>
        </div>
        <Button
          variant="subtle"
          leftSection={<IconArrowLeft size={16} />}
          onClick={() => navigate('/Counselling/Cases')}
        >
          Back to Cases
        </Button>
      </Group>

      <CreateCaseWizard
        onCancel={() => navigate('/Counselling/Cases')}
        onCreated={() => { /* wizard already navigates to the new case */ }}
      />
    </Container>
  );
}